import React, { useEffect, useMemo } from "react";

import { useDispatch, useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";

import { selectCompany } from "../../redux/reducers/chart-reducer";
import { ChartTable } from "../../components/ChartTable/ChartTable";
import { TopTable } from "../../components/TopTable/TopTable";
import { ChartSlider } from "../../components/ChartSlider/ChartSlider";
import { ChartGraph } from "../../components/ChartGraph/ChartGraph";
import { loadingChartCompanies } from "../../redux/reducers/chart-reducer";
import { selectContracts } from "../../redux/reducers/contract-reducer";
import Loader from "../../components/Loader/Loader";
import { chartDataCorrector } from "../../utils/chartDataCorrectors";
import { topDataCorrector } from "../../utils/chartDataCorrectors";
import { chartColumns } from "./chartColumns";
import { topColumns } from "./topColumns";
import { useState } from "react";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  chartGraph: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    borderRadius: "4px",
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
    transition: "all 0.2s ease-in-out",
  },
}));

export const ChartContainer = () => {



  const dispatch = useDispatch();
  const { selectedContract } = useSelector(selectContracts);

  const classes = useStyles();
  const columns = useMemo(() => chartColumns, []);
  const topcolumns = useMemo(() => topColumns, []);

  const { companies, selectedCompany, startTime, endTime, loading, selectedError, topList } =
    useSelector(selectCompany);



  useEffect(() => {
    
    dispatch(loadingChartCompanies(startTime, endTime, selectedContract.name));
  }, [dispatch, startTime, endTime, selectedContract.name]);


  let data = [];
  let topdata = [];
  const [slideData, setSlideData] = useState();

  if (selectedCompany) {

    data = chartDataCorrector(selectedCompany);
    topdata = topDataCorrector(topList);
    //setSlideData(data);
  }

  

  const changeState = (newData) => {

    if (newData) {
      setSlideData(newData);
    }

  }
  
  return data && topdata && !loading ? (
    <>
      <Grid
        container
        spacing={3}
        direction={"row"}
        className={classes.chartContainer}
      >
        <Grid item xs={12} sm={12} md={12} margin={1}>
          <Typography variant="h6">
            Ключевые показатели эффективности проекта ТиКРС ООО «ЛЗС»
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={6} margin={1}>
          <ChartTable data={data} columns={columns} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} margin={1}>
          <ChartGraph data={data} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} margin={1}>
          <TopTable data={topdata} columns={topcolumns} />
        </Grid>    

        <Grid item xs={12} sm={12} md={6} margin={1}>
          <ChartSlider changeState = {changeState}/>
        </Grid>               
      </Grid>
    </>
  ) : (
    <Loader />
  );
};